import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

/**
 * @link https://jotai.org/docs/utilities/storage#createjsonstorage-util
 */
const sessionJsonStorage = createJSONStorage(
  // getStringStorage
  () => sessionStorage // or sessionStorage, asyncStorage or alike
  // options (optional)
  // {
  //   reviver, // optional reviver option for JSON.parse
  //   replacer, // optional replacer option for JSON.stringify
  // },
);
const localJsonStorage = createJSONStorage(() => localStorage);

export const cartAtom = atomWithStorage('cart', [], sessionJsonStorage);
export const addToCartAtom = atom(null, (get, set, update: CartProduct) => {
  const cart = get(cartAtom) as CartProduct[];
  const currentProduct = cart.find((product) => product.id === update.id);

  if (!currentProduct) {
    set(cartAtom, [...cart, update]);
  } else {
    set(
      cartAtom,
      cart.map((product) => {
        if (product.id === currentProduct.id) {
          return { ...product, quantity: product.quantity + update.quantity };
        }
        return product;
      })
    );
  }
});

export const memberRedirectAtom = atomWithStorage(
  'memberRedirect',
  '',
  localJsonStorage
);
